import React, { useEffect } from 'react';

import cx from '@travel/design-system/core/src/utils/classNames';
import { CheckInCircle } from '@travel/icons/ui';
import { Animation } from '@travel/ui';

import styles from './snackbar.module.scss';

const enum Duration {
  Short = 4000,
  Long = 8000,
  None = 0,
}

type Props = {
  icon?: React.ReactNode;
  duration?: Duration;
  className?: string;
  isOpen?: boolean;
  callback?: () => void;
  children?: React.ReactNode;
};

const Snackbar = (props: Props) => {
  const {
    duration = Duration.Short,
    className,
    isOpen,
    callback,
    children,
    icon = <CheckInCircle size={20} color="white" className={styles.snackbarIcon} />,
  } = props;

  useEffect(() => {
    if (isOpen && duration && callback) {
      const timer = setTimeout(() => {
        callback();
      }, duration);

      return () => {
        clearTimeout(timer);
      };
    }
  }, [callback, duration, isOpen]);

  return (
    <Animation
      isStartAction={isOpen}
      type="fadeIn"
      animationDuration="short"
      wrapperClassName={cx(styles.wrapper, className)}
      data-testid="snackbar-wrapper"
    >
      {icon}
      {children}
    </Animation>
  );
};

export default Snackbar;
